var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceAlertIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_37487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_968_37487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.53674e-07H14V14H0V9.53674e-07Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_968_37487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48828 6.58984H0.410156V4.62566C0.410156 4.30175 0.506023 3.98511 0.685699 3.71561L1.8346 2.03325C1.98674 1.80504 2.24287 1.66797 2.51716 1.66797H10.3086L9.48828 6.58984Z",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35928 6.58984L3.71865 12.332H1.52492C0.979901 12.332 0.586452 11.8104 0.736159 11.2864L2.07803 6.58984",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53906 12.332H3.71875",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89844 4.12891V4.94922",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53906 4.12891V4.94922",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17969 4.12891V4.94922",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 1.66797L7.84766 6.58984",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65625 9.05078H6.37677C6.93871 9.05078 7.32809 8.50076 7.14789 7.96849C7.05082 7.68184 6.99996 7.37871 6.99996 7.07036V6.58984",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7708 2.1488C13.863 3.24069 13.863 5.01748 12.7708 6.10938",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6108 3.30859C12.0639 3.76163 12.0639 4.49619 11.6108 4.94922",
    stroke: "#3C7AF5",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_37487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAlertIcon);
export default __webpack_public_path__ + "static/media/device-alert-icon.73feb0de44441eedcebe9392e71b843e.svg";
export { ForwardRef as ReactComponent };